import React, { PropsWithChildren } from 'react';
import { TextContent, Text, TextVariants, } from '@patternfly/react-core';

import SmallAccordionButton from './SmallAccordionButton';

import './customization-section.css';
import SectionLabel from './SectionLabel';
import { ValidationStatus } from '../../store/global-types/customization-types';

interface CustomizationSectionProps {
    label: string,
    collapsedMessage: string,
    isExpanded: boolean,
    isModified: boolean,
    validationStatus?: ValidationStatus,
    /** @deprecated Use validationStatus instead. */
    isValid?: boolean,
    itemCount?: number,
    totalCount?: number,
    testId?: string,
    onClick: () => void,
}

const CustomizationSection = (props: PropsWithChildren<CustomizationSectionProps>) => {

    const { children, label, collapsedMessage, isExpanded, isModified, isValid, itemCount, totalCount, testId, onClick } = props;

    const badge = totalCount !== undefined && itemCount !== undefined ? `${itemCount} / ${totalCount}` : itemCount;

    // Support both new validationStatus prop and legacy isValid prop
    const resolvedValidationStatus = props.validationStatus ?? (isValid === false ? ValidationStatus.Error : ValidationStatus.Valid);

    return (
        <div className="customization-section" data-testid={testId || undefined}>
            <TextContent>
                <Text component="h3">
                    <SmallAccordionButton
                        isActive={isExpanded}
                        label={(<SectionLabel
                            label={label}
                            isModified={isModified}
                            validationStatus={resolvedValidationStatus}
                            badge={badge} />)}
                        onClick={onClick}
                        className="customization-section-accordion"
                        testId={testId ? `${testId}-accordion` : undefined} />
                </Text>
            </TextContent>
            <div className={isExpanded ? '' : 'is-collapsed'}>
                {children}
            </div>
            {!isExpanded && (<div className="section-hint"><Text component={TextVariants.small}>{collapsedMessage}</Text></div>)}

        </div>
    )
}

export default CustomizationSection;
